import polygonShapeFractory from './polygon_shape_factory';
import polylineShapeFractory from './polyline_shape_factory';
import { DrawText, DrawImage, DrawCamera } from './draw_symbol'

export default {
    // 圆
    draw_circle: polygonShapeFractory({ name: '圆', type: 'circle', fixedPointCount: 2 }),
    // 细直箭头
    draw_fine_arrow: polygonShapeFractory({ name: '细直箭头', type: 'fine_arrow', fixedPointCount: 2 }),
    // 椭圆
    draw_ellipse: polygonShapeFractory({ name: '椭圆', type: 'ellipse', fixedPointCount: 2 }),
    // 矩形
    draw_rectangle: polygonShapeFractory({ name: '矩形', type: 'rectangle', fixedPointCount: 2 }),
    // 突击方向
    draw_assault_direction: polygonShapeFractory({ name: '突击方向', type: 'assault_direction', fixedPointCount: 2 }),
    // 钳击 
    draw_double_arrow: polygonShapeFractory({ name: '钳击', type: 'double_arrow', fixedPointCount: 4 }),
    // 扇形
    draw_sector: polygonShapeFractory({ name: '扇形', type: 'sector', fixedPointCount: 3 }),
    // 弓形
    draw_lune: polygonShapeFractory({ name: '弓形', type: 'lune', fixedPointCount: 3 }),
    // 进攻箭头
    draw_attack_arrow: polygonShapeFractory({ name: '进攻箭头', type: 'attack_arrow', fixedPointCount: Infinity }),
    // 燕尾进攻箭头
    draw_tailed_attack_arrow: polygonShapeFractory({ name: '燕尾进攻箭头', type: 'tailed_attack_arrow', fixedPointCount: Infinity }),
    // 战斗小队 ？？？啥意思
    draw_squad_combat: polygonShapeFractory({ name: '战斗小队', type: 'squad_combat', fixedPointCount: Infinity }),
    // 闭合曲面
    draw_closed_curve: polygonShapeFractory({ name: '闭合曲面', type: 'closed_curve', fixedPointCount: Infinity }),

    // 曲线
    draw_curve: polylineShapeFractory({ name: '曲线', type: 'curve', fixedPointCount: Infinity }),
    // 弧线
    draw_arc: polylineShapeFractory({ name: '弧线', type: 'arc', fixedPointCount: 3 }),

    draw_text: DrawText,
    draw_image: DrawImage,
    draw_camera: DrawCamera,
};
